<template>
	<div>
		<!-- 时间筛选 -->
		<el-row style="margin: 15px 0;">
			<el-col :span="24">
				<el-button type='text' size="mini" v-show="$route.params.id" @click="$router.back(-1)">
					返回上一级
				</el-button>
				<el-button type='primary' style="float: right;" v-show="$route.params.id" @click="addUserDialogVisible = true">
					添加账号
				</el-button>
				<!-- <el-date-picker style="float: right; margin-left: 15px;" v-model="date_range" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        value-format="yyyy-MM-dd" @change="getList">
        </el-date-picker> -->
			<div style="float: right;">
				<el-input style=" width: 200px; margin-right: 15px;" v-model="keywords" placeholder="手机号" >
					<el-button slot="append" icon="el-icon-search" @click="handleCurrentChange(1)"></el-button>
				</el-input>
				<el-select v-model="user_type" v-show="!company_id"
				           placeholder="请选择状态" @change="handleCurrentChange(1)">
				  <el-option v-for="item in userTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
				</el-select>
			</div>
			</el-col>
		</el-row>
		<!-- 表格 -->
		<el-table border stripe :data="list" style="width: 100%">
			<el-table-column prop="id" :label="company_id ? '用户ID' : '公司ID'" width="180"></el-table-column>
			<el-table-column :prop="company_id ? 'nickname' : 'name'" :label="company_id ? '用户名称' : '公司名称'"
				width="140"></el-table-column>
			<el-table-column prop="phone_number" label="手机号" width="150"></el-table-column>
			<el-table-column prop="created_at" label="创建时间" width="200"></el-table-column>
			<el-table-column label="子用户" fixed="right" v-if="!company_id">
				<template slot-scope="scope">
					<el-button type='text' size="mini" @click="toUser(scope.row)">
						编辑
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="user_count" label="账号数" v-if="!company_id">
				<template slot-scope="scope">
					<el-button type="text" @click="openUserCountDialog(scope.row.id)">{{scope.row.user_count}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="money" label="余额" v-if="user_type == 1 && company_id">
				<template slot-scope="scope">
					<span>{{scope.row.money}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="company_id ? '用户权限' : '公司权限'" min-width="180" fixed="right">
				<template slot-scope="scope">
					<el-button :type="statusColor[item.status] || 'info'" size="mini" class="mb-1"
						v-for="(item,index) in scope.row.module" :key="index"
						@click="beforeOperate(item,getCompanyModuleDes(company_id ? scope.row.nickname : scope.row.name,item.name,item.status),toggleStatus)">
						{{item.name}}
						<!-- 0未开启   1体验  2永久 -->
						<span v-if="item.status == ''">(未拥有)</span>
						<span v-if="item.status === 1">({{item.expiration_time}}到期)</span>
						<span v-if="item.status === 2">(已拥有)</span>
					</el-button>
					<el-button v-show="user_type == 1 && company_id" size="mini" class="mb-1" @click="openAddMoneyDialog(scope.row.id)">充值</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<div style="padding: 15px 0; text-align: right;">
			<el-pagination :hide-on-single-page="true" background @current-change="handleCurrentChange"
				:current-page="pagination.page" :page-size="pagination.page_size"
				layout="total, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</div>
		<div style="height: 100px;"></div>

		
		<!-- 添加子用户 -->
		<el-dialog custom-class="add-user-dialog" title="添加子用户" :visible.sync="addUserDialogVisible" width="400px">
		  <el-form :model="addUserForm" ref="addUserDialogForm" :inline="true">
			  <div class="mv-2" style="margin-top: -20px;">子用户手机号</div>
			  <el-form-item
			      label="手机号"
			      prop="phone_number"
			      :rules="[
			        { required: true, pattern: /^1\d{10}$/, message: '请输入正确手机号',trigger: 'blur'},
			      ]"
			    >
			    <el-input type="text" v-model="addUserForm.phone_number" placeholder="手机号" />
			    </el-form-item>
			  <div class="mv-2">选择权限</div>
			  <el-checkbox-group v-model="modules">
			      <el-checkbox v-for="(item,index) in moduleList" :key="index" :label="item.name"></el-checkbox>
			      <!-- <el-checkbox label="算料" true-label="2"></el-checkbox> -->
			      <!-- <el-checkbox label="修改公式" true-label="3"></el-checkbox> -->
			  </el-checkbox-group>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="resetAddUserForm">取 消</el-button>
		    <el-button type="primary" @click="addAcount">确 定</el-button>
		  </span>
		</el-dialog>
		
		<!-- 代理商充值 -->
		<el-dialog title="充值" :visible.sync="addMoneyDialog" width="400px">
		  <el-form :model="addMoneyForm" ref="addMoneyDialogForm" :inline="true">
			  <el-form-item
			      label="充值金额"
			      prop="money"
			      :rules="[
			        { required: true,type: 'number' ,message: '请输入充值金额',trigger: 'blur'},
			      ]"
			    >
			    <el-input type="number" v-model.number="addMoneyForm.money" placeholder="请输入充值金额" />
			    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="resetAddMoneyForm">取 消</el-button>
		    <el-button type="primary" @click="addMoneyConfirm">确 定</el-button>
		  </span>
		</el-dialog>
		
		<!-- 更改子账号数量 -->
		<el-dialog title="充值" :visible.sync="userCountDialog" width="400px">
		  <el-form :model="userCountForm" ref="userCountDialogForm" :inline="true">
			  <el-form-item
			      label="账号数量"
			      prop="user_count"
			      :rules="[
			        { required: true,type: 'number' ,message: '请输入账号数量',trigger: 'blur'},
			      ]"
			    >
			    <el-input type="number" v-model.number="userCountForm.user_count" placeholder="请输入账号数量" />
			    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="resetUserCountForm">取 消</el-button>
		    <el-button type="primary" @click="userCountConfirm">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: "payment-log",
		data() {
			return {
				keywords: '',
				user_type: 0,
				list: [],
				pagination: {
					page: 1,
					total: 400,
					page_size: 15
				},
				statusColor: {
					0: 'info',
					1: 'warning',
					2: 'success'
				},
				note_dialog: {
					show: false,
					note: '',
					id: 0
				},
				company_id: '',
				addUserDialogVisible: false,
				addUserDialogValidateForm: false,
				moduleList: [],
				modules: [],
				addUserForm:{
					phone_number: '',
					model_info: []
				},
				userTypeList: [
					{text: '非代理商', value: 0},
					{text: '代理商', value: 1}
				],
				addMoneyDialog: false,
				addMoneyForm: {
					money: ''
				},
				targetId: ''  ,//修改账号子账号的公司id,
				userCountDialog: false,
				userCountForm: {
					user_count: ''
				}
			}
		},
		methods: {
			handleCurrentChange(page) {
				this.pagination.page = page;
				this.getList();
			},
			getList() {
				let params = {
					page: this.pagination.page,
					// start_date: this.date_range[0],
					// end_date: this.date_range[1],
					user_type: this.user_type,
					phone_number: this.keywords,
				};
				var url = 'admin-select-user'
				if (this.company_id) {
					params.company_id = this.company_id
					url = 'admin-get-company-user'
					delete params.user_type
				}
				this.list = [];
				this.$axios.get(url, params).then(res => {
					if(!res.code){
						this.$message.error('列表获取失败')
						return 
					}
					this.list = res.data.data;
					this.pagination.total = res.data.total;
				});
			},
			// 模块类型列表
			getModuleList() {
				var params = {
					company_id: this.company_id
				}
				this.$axios.get('url', params).then(res => {
					if(!res.code){
						this.$message.error('模块类型列表获取失败')
						return 
					}
					this.moduleList = res.data.data;
				});
			},
			// 操作前的确认
			beforeOperate(e, notice, next) {
				this.$alert(notice, '提示', {
					confirmButtonText: '确定',
					showCancelButton: true,
					cancelButtonText: '取消',
					callback: action => {
						if (action == 'confirm') next(e)
					}
				});
			},
			toggleStatus(item) {
				if(item.status > 1 && !this.company_id) {
					this.$message.error(`该公司账号已拥有${item.name}权限,无法关闭`)
					return ;
				}
				let params = {
					module_id: item.module_id,
				},
					url = '';
				if(this.company_id) {  //子用户修改
					params.user_id = item.user_id
					params.operate_type = item.status != 2 ? 2 : 0
					url = 'admin-set-user-modules'
				}else{   //公司修改
					params.company_id = item.company_id
					url = 'admin-add-company-modules'
				}
				this.$axios.post(url, params).then(res => {
					if(!res.code){
						this.$message.error(res.message)
						return 
					}
					this.$message.success(res.message)
					this.getList()	
				}).catch((reason) =>{
					this.$message.error(reason)
				});
			},
			// 公司添加子用户
			addAcount() {
				this.$refs['addUserDialogForm'].validate((valid) =>{
					if(valid) {
						this.addUserForm.model_info = []
						this.modules.forEach((v) =>{
							let choosed = this.moduleList.filter((item) =>{
								return item.name == v
							})[0],authority = {};
							authority[choosed.module_id] = choosed.status
							this.addUserForm.model_info.push(authority)
						})
						this.addUserForm.company_id = this.company_id
						this.$axios.post('admin-add-company-user', this.addUserForm).then(res => {
							if(!res.code){
								this.$message.error(res.message)
								return 
							}
							this.$message.success('添加成功')
							this.getList()
							this.resetAddUserForm()
						});
					}
				})
			},
			// 前往子用户编辑
			toUser(row) {
				this.$router.push({
					name: '子用户管理',
					params: {
						id: row.id
					},
					query: {
						au: encodeURIComponent(JSON.stringify(row.module.filter((v) =>{return v.status > 0}))),
						user_type: this.user_type
					}
				})
			},
			// 操作提示
			getCompanyModuleDes(n, mn, s) {
				return `确定给${n}${s > 1 ? '关闭' : '开启'}${mn}权限?`
			},
			// 重置
			resetAddUserForm() {
				this.modules = []
				this.addUserDialogVisible = false
				this.$refs['addUserDialogForm'].resetFields()
			},
			// 充值
			addMoneyConfirm() {
				this.$refs['addMoneyDialogForm'].validate((valid) => {
				  if (valid) {
					this.$axios.post('admin-up-dls-money', this.addMoneyForm).then(res => {
						if(!res.code){
							this.$message.error(res.message)
							return 
						}
						this.$message.success('添加成功')
						this.getList()
						this.resetAddMoneyForm()
					});
				  } else {
					return false;
				  }
				});
			},
			openAddMoneyDialog(id) {
				this.addMoneyForm.user_id = id
				this.addMoneyDialog = true
			},
			resetAddMoneyForm() {
				this.addMoneyDialog = false
				this.$refs['addMoneyDialogForm'].resetFields()
			},
			openUserCountDialog(id) {
				this.targetId = id
				this.userCountDialog = true
			},
			resetUserCountForm() {
				this.userCountDialog = false
				this.$refs['userCountDialogForm'].resetFields()
			},
			userCountConfirm() {
				this.$refs['userCountDialogForm'].validate((valid) => {
				  if (valid) {
					this.$axios.put('admin-up-company-users/'+ this.targetId, this.userCountForm).then(res => {
						if(!res.code){
							this.$message.error(res.message)
							return 
						}
						this.$message.success('修改成功')
						this.getList()
						this.resetUserCountForm()
					});
				  } else {
					return false;
				  }
				});
			}
		},
		mounted() {
			this.company_id = this.$route.params.id || ''
			this.user_type = this.$route.query.user_type || 0
			if(this.company_id) this.moduleList = JSON.parse(decodeURIComponent(this.$route.query.au))
			// this.getModuleList()
			this.getList();
		}
	}
</script>
<style lang="scss" scoped>
	.mb-1 {
		margin-bottom: 4px;
	}
	.mv-2{
		margin: 8px 0;
	}
</style>
